module.exports = __webpack_public_path__ + "img/202312_05.f0ffbf36.jpg";